import React from 'react';
import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import BoldIcon from '../../../../assets/icons/BoldIcon';
import ItalicIcon from '../../../../assets/icons/ItalicIcon';
import {WHATSAPP_MAX_TEXT_LENGTH} from '../../../../pages/branding/whatsAppScreen/whatsAppValidation';
import * as css from './WhatsAppEditorFooter.css';
import {TXHR} from '../../../../assets/constants/constansts.type';

interface WhatsAppEditorFooterProps {
    hasChanged: boolean;
    totalCharacters: number;
    isCharCountExceeded: boolean;
    onFormat?: (command: string) => void;
    save: {
        onSave?: () => void;
        disabled?: boolean;
        xhr?: TXHR;
        text?: string;
    };
}

function WhatsAppEditorFooter({
    hasChanged,
    totalCharacters,
    isCharCountExceeded,
    onFormat,
    save
}: WhatsAppEditorFooterProps) {
    const {t} = useTranslation('branding');

    return (
        <css.footer data-cy="whatsapp-editor-footer">
            <css.formattingToolbar>
                {onFormat && (
                    <>
                        <Button
                            variant="primary"
                            onClick={() => onFormat('bold')}
                            title="Bold"
                            iconStart={<BoldIcon />}
                            data-cy="whatsapp-editor-bold-btn"
                        />
                        <Button
                            variant="primary"
                            onClick={() => onFormat('italic')}
                            title="Italic"
                            iconStart={<ItalicIcon />}
                            data-cy="whatsapp-editor-italic-btn"
                        />
                    </>
                )}
                <css.charCounter isExceeded={isCharCountExceeded} data-cy="whatsapp-editor-char-counter">
                    {totalCharacters}/{WHATSAPP_MAX_TEXT_LENGTH}
                </css.charCounter>
            </css.formattingToolbar>
            {save.onSave && (
                <Button
                    variant="brand"
                    disabled={!hasChanged || save.disabled}
                    onClick={save.onSave}
                    title="Save"
                    size='category'
                    data-cy="whatsapp-editor-save-btn"
                    xhrState={save.xhr}
                >
                    {save.text ?? t('save')}
                </Button>
            )}
        </css.footer>
    );
}

export default WhatsAppEditorFooter;
